import { render, staticRenderFns } from "./ItemConfig.vue?vue&type=template&id=76c1d9d6&scoped=true"
import script from "./ItemConfig.vue?vue&type=script&lang=js"
export * from "./ItemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1d9d6",
  null
  
)

export default component.exports